/* eslint-disable no-console */
import { InputNumber, Space, Typography } from 'antd'
import React from 'react'
import UldDropdown from './uldDropdown'

const { Text } = Typography
const INPUTPROPS = {
  className: 'ac-ip',
  type: 'number',
  size: 'small',
  bordered: false,
  // min: 1,
  // max: 10,
  controls: false,
}
const acContainer = (props) => {
  return (
    <Space.Compact direction='horizontal'>
      <div className='container-block'>
        <div className='container-inner-block container-left-block'></div>                 
        <div className='container-inner-block container-left-block'></div>                 
        <div className='container-inner-block container-left-block'></div>                 
      </div>
      <div className={`WB-container ${props.className ? ` ${props.className}` : ''}`}>
        <div className='ULD-wrapper'>
          <Text className={`container-header ${props.ipDisabled ? 'container-header-disabled' : ''} ${props.uldSelect ? 'title-uld' : ''}`}>{props.name}</Text>
          {props.uldSelect && (
            <UldDropdown 
              name={props.name}
              fqa={props.fqa}
              onePair={props.onePair}
              ac_type={props.ac_type}
              value={props.uldValue} 
              onChange={(e)=>props.uldOnChange(e)}
              disabled={props.uldDisabled}
              onSubmit={props.onSubmit}
            />
          )}
        </div>
        <div className='container-data'>
          <InputNumber
            {...INPUTPROPS}
            value={props.ipValue}
            onChange={props.ipOnChange}
            disabled={props.ipDisabled}
            onBlur={props.onSubmit}
          />
          <div className='container-bags'>
            {props.uld && props.uld }
            {!props.uld && props.isBag && 'Bags'}
          </div>
        </div>
      </div>
      <div className='container-block'>
        <div className='container-inner-block container-right-block'></div>                 
        <div className='container-inner-block container-right-block'></div>                 
        <div className='container-inner-block container-right-block'></div>                 
      </div>
    </Space.Compact>
  )
}

export default acContainer